import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CodeAssistantPage } from '@/features/ai/assist/code-assistant-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Projet → « Assistant de code » : expliquer, générer, compléter (`POST /assist/code`). */
export const Route = createFileRoute('/$tenant/projects/$projectId/code-assistant')({
  component: CodeAssistantRoute,
});

function CodeAssistantRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="codeAssistant"
      crumbs={[{ label: t('nav.items.codeAssistant') }]}
    >
      <CodeAssistantPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
